import React from 'react'
import { Text, View, Card, useStyles } from '@ion-ui/core'
import { useMediaQuery } from 'react-responsive'
import planList from '../../assets/svg/requisitos.svg'
import cloudReq from '../../assets/svg/nube_requisitos.svg'
import { Styles } from './styles'

const personalRequeriments = [
  'Tener entre 21 y 69 años de edad.',
  'Contar con un buen historial crediticio.',
  'Ingresos comprobables.'
]

const warrentyRequeriments = ['La propiedad que dejes como garantía debe estar libre de gravamen.']

const Requeriments = () => {
  const styles = useStyles(Styles)
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <View variant='section' css={styles.curveBack}>
      <View css={styles.subMain}>
        <View css={styles.contain}>
          <View css={styles.inline}>
            <Text variant={isMobile ? 'h5' : 'h3'}>Requisitos</Text>
            <img
              src={planList}
              alt='plan list'
              width='140'
              height='140'
            />
          </View>
          <Text variant='subtitle' css={styles.subtitle}>
            Queremos verte feliz, no preocupado.
            Para asegurarnos de que este crédito
            sea correcto para ti, necesitarás los
            siguientes requisitos:
          </Text>
        </View>
        <View>
          <Card variant='requirements' css={styles.card}>
            <Text variant='h6' css={styles.titleCard}>Personales</Text>
            <View variant='ul' css={styles.list}>
              {personalRequeriments.map((elem, index) =>
                <View variant='li' key={elem + '_' + index}
                  css={styles.listElement}>
                  <img
                    src={cloudReq}
                    alt={`Requerimiento ${index + 1}`}
                    width='32'
                    height='32'
                  />
                  <Text variant='subtitle'>{elem}</Text>
                </View>
              )}
            </View>
          </Card>
          <Card variant='requirements' css={styles.card}>
            <Text variant='h6' css={styles.titleCard}>De tu garantía</Text>
            <View variant='ul' css={styles.list}>
              {warrentyRequeriments.map((elem, index) =>
                <View variant='li' key={elem + '_' + index}
                  css={styles.listElement}>
                  <img
                    src={cloudReq}
                    alt={`Requerimiento ${index + 1}`}
                    width='32'
                    height='32'
                  />
                  <Text variant='subtitle'>{elem}</Text>
                </View>
              )}
            </View>
          </Card>
        </View>
      </View>
    </View>
  )
}

export default Requeriments
